module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "CHAPTER 2: Daily Bread"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9780310412625_epub_toc_r1#c02a"
    }
  }, [_c('span', {
    staticClass: "sm1"
  }, [_vm._v("CHAPTER 2")]), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Daily Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Wisdom is better than weapons of war.")]), _vm._v(" "), _c('br'), _vm._v(" ECCLESIASTES 9:18"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_c('em', [_vm._v("I")])])]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWOKE TO WARM SUNLIGHT FILTERING THROUGH MY EYELIDS.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first thought was that I should turn out and get moving, but the idea of rising only to find the horrible scene of the previous night fully exposed to the light of day kept me prone upon my blanket, eyes tightly closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Someone’s boot tapped the side of mine—once, twice, three times. “Rise and shine, Palmer, rise and shine. You don’t want to waste this bloody fine day abed, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Sergeant Needham spoke, new recruits like me listened. His voice was actually quite pleasing, for he spoke with a decidedly British accent, and his words were confident and sure. Sergeant Needham commanded immediate obedience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Sarge,” I answered, opening my eyes just enough to see him standing over me. “I mean, no, Sarge … I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robinson’s got the fire going and the bloody coffee is almost ready. Adams and Whitting have gone off to find some clean water, should be back within the hour. Mind if I throw my meat into your pan this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Sarge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Sergeant Needham was known as an “old soldier,” not in reference to his age, for he had certainly not yet reached his fortieth year, but rather as a concise and complimentary expression of the value of a man who had met the foe on the battlefield and learned the hard lessons of earlier campaigns. From the day Company C had mustered in at Camp Foote in Hartford, Needham had insisted that we call him “Sarge, just Sarge.” Sarge had a full head of bushy hair the color of fine beach sand. Bushy eyebrows framed his piercing gray eyes, and an equally bushy moustache hid his upper lip. He had surely once been handsome, when his youthful face was smooth and unmarked. Now his regular features were deeply lined by weather and war, a visible testament to the hardness of the man. Of less than average height—closer to five feet than to six, and quite thin, not more than one hundred and thirty pounds —Sarge’s confident manner and wealth of battlefield wisdom caused one to disregard his diminutive size and rather consider him a man to be reckoned with. He had a habit of saying “bloody this” or “bloody that,” as in “You lads don’t know bloody nothing, but you’re bloody well gonna learn.” Yet I never heard him take the Lord’s name in vain, nor did any other curse escape his lips in my hearing, as was so common among his peers.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good morning, Michael.” John’s tall frame was hunched over the campfire; his voice was bright and cheery. “Did you sleep well?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stood and stretched. “No, not very.” In fact, not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gazed about the field. The burial details had worked through the night. All the bodies of the slain had been removed; only traces remained of the recent carnage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“It’ll be our turn soon, lads,” said Sarge, as if he could read my thoughts. “The Rebs have already taken Harper’s Ferry, so they’ll probably make a stand up near Hagerstown. First we march — another day ought to do it. Then we fight, and if I ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("read the signs correctly, it’ll be a bloody great fight—tomorrow maybe, or Wednesday.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Coffee’s ready,” John said. Sarge and I waited eagerly as John poured the hot brew from the blackened coffee tin into three tin coffee cups.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see you boys have learned well,” said Sarge, lifting his cup and savoring the aroma. “Smells great. It’s a small thing, really, but a soldier needs a bloody good cup of coffee whenever he can get one. And you’re keeping your coffee and sugar together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Sarge,” John and I answered in unison. “We’ll never have one without the other.” Sarge laughed as we recited his own words back to him in our best, though admittedly poor, imitations of his British accent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John poured the last of the water in his canteen into the coffee tin and set the can on the ground before us. “That’s for the pork.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each man reached into his own haversack, took out a slab of salt pork, and held it under his nose to see if it would curl his nose hairs. Approved for consumption, the pork was tossed into the tin can to soak some of the salt out of it. John got a small skillet from his pack and, after a few minutes, transferred the slabs of pork from the tin can to the skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wisdom of an old soldier can never be valued too highly. Whenever Sarge happened by our campfire, which had been twice since leaving Fort Ethan Allen in Arlington, he always imparted some lesson or other he had learned while soldiering. “Are you and Adams friends?” he asked this time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Acquaintances rather than friends. I see him at the store and about town. I really don’t know him well. He says he got into this because life at home was too boring.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("“He’s a bloody muscular young fellow, though,” said Sarge. “Looks about twice your size, Palmer, but not an inch taller. He knows next to nothing about what he’s gotten himself into, ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("but he’s tough. He’ll likely become a fine soldier. But I am a bit concerned about Whitting.”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Harry told me he joined up because he didn’t want people to think poorly of him,” John said. “He didn’t want to enlist but thought everyone expected him to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When we left for Camp Foote,” I added, “his mother cried and cried and wouldn’t let go of Harry at the train station. It was as if she was seeing her son for the last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” said Sarge, “Mrs. Whitting may have been right. Her boy drills bloody well, but he seems weak in both body and spirit. He’s pale and he has nervous eyes, so I don’t quite know what to expect from him. Keep an eye on him. I will too, but I fear his experience of this war will be bloody short.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s it like, Sarge?” The question had been tormenting me all night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Needham looked at me, puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Battle, I mean. What’s it like when the firing starts in earnest?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rough, very rough,” he said. “You’ll know shortly. The bloody Rebs fight hard. They think they’re independent from the United States. That makes us foreign invaders, so they’re fighting to defend their homeland. Their officers are first-rate and the men fight well. Sometimes we’ve had to attack the Rebs in their defenses, and more of our boys are killed than theirs. It’s the price we have to pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you afraid?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Always. You will be too — every man is, though he may not admit it. And the fear will be there no matter what you do. It’s like a shadow that follows me wherever I go. I’ve learned to expect it and deal with it so I control it rather than letting it control me, but if any man tells you he’s not afraid, run away as fast and far as you can. It will be more perilous to be in his company than to be with a hundred bloody cowards.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("“So how "), _c('em', [_vm._v("do")]), _vm._v(" you deal with it?” I asked.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarge paused for a moment, watching keenly as John stirred and flipped the sizzling pork. “How old are you, Palmer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thirty-four now, Sarge. My birthday was two days after we arrived at Camp Foote.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robinson?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thirty-six, Sarge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I knew you two were older than most of the other fellows. Married?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We both nodded. “Yes, Sarge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Children?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three, Sarge, two sons and a daughter,” John said. “Michael has one of each. What about you, Sarge?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Five beautiful children,” Sarge answered, proudly holding up the five fingers of his right hand. “But two died just after they were born.” His eyes clouded for a moment, then brightened. “My childhood sweetheart’s family lived next to my family on Trentham Street in Birmingham. Still do. We married as soon as our parents would agree to it, almost fifteen years ago. I worked years in a bloody shoe factory and dreamed of coming to America. But the babies arrived every other year, as if on a schedule, and any plans for coming here had to be put off. I finally came over on a steamship out of Liverpool in April of fifty-eight. A family friend lived in Waterbury. He took me in and I was able to send for my family six months later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you’ve only been in America for four years?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you’re fighting in this war?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe not. The Union Jack is very dear to me, but Old Glory is my flag now. America is my bloody country, so her wars are my wars.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“Leaving home was most difficult for us too, Sarge,” I said quietly. “We’ve been gone just five weeks, but already I miss my wife terribly … and my children too.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At the fire John nodded his agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye, that’s the rub, Palmer, and you older fellows know it far better than these bloody young ones. You long to be with your lifelong companion just as she longs for you. For me, it’s a deep and keen ache for which there is no balm. "), _c('em', [_vm._v("Bittersweet")]), _vm._v(" is the word I use for it. The pain is always there along with the fear, but it’s what helps me do what must be done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?” John asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would like nothing better than to be done with this war and go home, but I know the best thing I can do for my wife and children is what I’m doing now, fighting the bloody Rebs so my family can live in a united and free nation. I expect it’ll be the same for you, and I wish I could say the ache will heal, but it’ll only worsen with the passage of time. The only remedy is victory —or perhaps, if God wills it, the final muster call.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John and I looked blankly at Sarge, not understanding his meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Death,” he whispered. “Death is the final muster call.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For several seconds Sarge gazed into the flames. Then his eyes fixed on John. “Are we frying the hardtack today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Sarge, just like you told us,” John said, “and this pork has some good fat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarge nodded. “You can crumble the crackers into your coffee too. They’ll soak up the coffee and get nice and soft. I haven’t seen any bloody weevils in the crackers yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Weevils?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bugs. Sometimes the crackers get infested, so always check your coffee before you drink it. If there are any weevils, the boiling will kill them and the bloody buggers will float to the top. Won’t hurt you to eat one, but the coffee is better without.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("The pork now cooked, John speared each slab with a fork and placed it on one of our tin plates. Each man anted up two hardtack crackers and John set to work over the fire again.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You asked me how I deal with fear, Palmer. I’ll speak only another word or two about it, and then I’ll say no more. Why does a bullet strike one man and not another?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The hand of God,” John replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right you are. If you believe as I do that the Almighty controls these things, then it’s best to leave matters of life and death in His hands. Am I afraid to die? I’ve thought much about this, and I think that I’m not so much afraid of death because I know what my end will be. But the uncertainty of the circumstances—if it’s in the next days or weeks, or if I’ll suffer much or little—that’s what troubles me. And I’m afraid of leaving my wife widowed and my children fatherless.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A minute or two passed, the only sound around our fire the crackle of hard crackers in a pan of hot pork fat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarge cleared his throat. “I’ve written a letter to help me be prepared, whenever that time might be—a pocket letter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pocket letter?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To my wife. Some veterans call it a death letter, but I like my name better. Nobody knows his time, so a few days ago I wrote a letter to my wife. I keep it in the breast pocket of my jacket, right here.” Sarge gently tapped the spot with his hand. “A lot of veteran soldiers carry them. The letter will be sent to my wife only if I’m killed. Captain Carpenter knows about it. I think every man would be best served by doing the same.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“At Bull Run, when the air was bloody thick with hot lead and the whole world seemed to be ending around us, I knew the next moment might be my last on this bloody earth, and I took comfort from having that letter in my pocket. I knew that whatever happened to me, I had left nothing unsaid to my dear ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("wife that should have been said, and at least she would have that simple letter as a remembrance.”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were at Bull Run, Sarge?” John said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was. I volunteered for three months with the First Connecticut right after Sumter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did your duty, Sarge,” John said. “You didn’t have to reenlist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, probably not. I went home after my three months thinking the bloody war would end soon, but this summer, when President Lincoln called for three hundred thousand more men, I thought he was calling me back. Slavery’s a bad business, and we have to whip those bloody Rebs and put an end to it. If we don’t save this country, it’ll be torn apart and all is lost.” When Sarge put it like that, it seemed a simple thing to press onward toward victory, but I knew it was not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Breakfast is served,” John announced as he deftly flipped two now golden-brown hardtack crackers onto each plate. “Spoons or fingers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We from the old country always use our best silver,” Sarge spoke with unabashed pride, “but no manners are expected from revolutionists such as you.” John and I doubled up with laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Around our fire we always give thanks and ask God’s blessing on our food,” John told Sarge when we had recovered sufficiently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would be pleased to do so,” Sarge said, and when his prayer was done, the three of us ate our plain and meager fare with gladness.")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3356f8ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780310412625_epub_c02_r1.vue
// module id = 84
// module chunks = 0